import { Header } from "../../shared/Style/Style";
import { TrainerWrapper } from "../components/TrainerWrapper";

export const TrainerCreate = () => (
    <TrainerWrapper>
        <Header>Створення тренажера</Header>
    </TrainerWrapper>    
);
